import React from 'react'

export default function ProgressBar( { value } ) {
  return (
    <div className="border border-gray-300 w-full h-4 flex items-center rounded-md relative overflow-hidden">
      <div className={`text-xs text-black bg-[#AFC836] h-full rounded-md`} style={{ width: `${value}%`}}>
      </div>
    </div>
  )
}
